module.exports = __webpack_public_path__ + "static/img/data1-img.e1f8665e.png";